// assets/frontend/src/js/catalog-filters.js
// ───────────────────────────────────────
// Gestión interactiva de filtros en catálogos de recursos.
// - Envío automático del formulario al cambiar un select (debounce).
// - Actualización de la URL con history.replaceState antes de recargar.
// - Chips de filtros activos: clic para quitar un filtro individual.
// - Botón "Limpiar todo": resetea todos los filtros.

import '../styles/catalog-filters.scss';

document.addEventListener('DOMContentLoaded', initCatalogFilters);

/**
 * Inicializa la barra de filtros mejorada ([data-filter-form]).
 * El contenedor envuelve tanto los chips como el <form> de selects.
 */
function initCatalogFilters() {
  const container = document.querySelector('[data-filter-form]');
  if (!container) return;

  const form = container.querySelector('form');
  if (!form) return;

  // ── Envío automático al cambiar un filtro ──
  const inputs = container.querySelectorAll('[data-filter-input]');
  let debounceTimer = null;

  inputs.forEach((input) => {
    input.addEventListener('change', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        submitFilters(form);
      }, 150);
    });
  });

  // ── Chips de filtros activos (quitar un filtro individual) ──
  const chips = container.querySelectorAll('[data-remove-filter]');
  chips.forEach((chip) => {
    chip.addEventListener('click', (e) => {
      e.preventDefault();
      const filterName = chip.dataset.removeFilter;
      clearFilter(form, filterName);
    });
  });

  // ── Botón "Limpiar todo" ──
  const clearAll = container.querySelector('.active-filter-chip--clear-all');
  if (clearAll) {
    clearAll.addEventListener('click', (e) => {
      e.preventDefault();
      clearAllFilters(form);
    });
  }
}

/**
 * Construye la query string desde el formulario (sin "page" ni valores
 * vacíos), actualiza la URL con history.replaceState y envía el formulario.
 */
function submitFilters(form) {
  const params = new URLSearchParams();

  form.querySelectorAll('select[name], input[name]').forEach((el) => {
    if (el.name === 'page') return;
    if (el.value && el.value !== '') {
      params.set(el.name, el.value);
    }
  });

  const queryString = params.toString();
  const url = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`;
  window.history.replaceState({}, '', url);
  form.submit();
}

/**
 * Quita un filtro individual (vacía su select) y reenvía.
 */
function clearFilter(form, filterName) {
  const select = form.querySelector(`[name="${filterName}"]`);
  if (select) {
    select.value = '';
    submitFilters(form);
  }
}

/**
 * Resetea todos los filtros del formulario y reenvía.
 */
function clearAllFilters(form) {
  form.querySelectorAll('select[name], input[name]').forEach((el) => {
    if (el.tagName === 'SELECT') {
      el.selectedIndex = 0;
    } else if (el.type === 'text' || el.type === 'search') {
      el.value = '';
    }
  });
  submitFilters(form);
}

export { initCatalogFilters };
